var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clearfix mg_bot50",attrs:{"id":"deposit_pages"}},[_c('base-deposit-withdraw-history')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }